import { normalizeForDirty } from "../../utils/normalizeForDirty.js";

// 比較用のスナップショット。"" と null の違い（マウント時の値の正規化など）では保存しない
const toSnapshot = (values) => JSON.stringify(normalizeForDirty(values));

// デモ入力の自動保存で「どの状態を保存済みとみなすか」を管理する。
// save … JSON 文字列を受け取り、保存できたら true を返す関数（demoStorage の saveDemoInput）
export const createDemoDraftTracker = (save) => {
  // 最後に保存した内容のスナップショット。自動保存の差分判定に使う
  let lastSnapshot = null;

  const write = (values, snapshot) => {
    if (!save(JSON.stringify(values))) return false;
    lastSnapshot = snapshot;
    return true;
  };

  return {
    // 書き込まずに、この内容を保存済みとして記録する（復元直後・リセット直後）
    markSaved: (values) => {
      lastSnapshot = toSnapshot(values);
    },
    // 最後に保存した内容と違うときだけ保存する。スキップしたら null、それ以外は保存の成否
    saveIfChanged: (values) => {
      const snapshot = toSnapshot(values);
      return snapshot === lastSnapshot ? null : write(values, snapshot);
    },
    // 差分に関係なく保存する。localStorage が外から変わる場合もあるため
    saveNow: (values) => write(values, toSnapshot(values)),
  };
};
